/* 固態／液態：捲動驅動（2026-08-18 Mars 拍板）。
   段落釘住一屏，捲動進度前半顯示固態、過半自動切傳統液態——兩種一定都看到。
   點分頁＝跳到對應捲動位置。prefers-reduced-motion 退回純點擊切換。 */
if (!window.__tsSolidInit) {
  window.__tsSolidInit = 1;
  (function () {
    function start() {
      var sec = document.querySelector("[data-ts-solidscrub]");
      var box = sec ? sec.querySelector(".ssb__box") : document.querySelector(".ts-air .ssb__box");
      if (!box) return;
      var tabs = [].slice.call(box.querySelectorAll(".ssb__tab"));

      function go(want) {
        box.classList.toggle("show-solid", want === "solid");
        box.classList.toggle("show-liquid", want === "liquid");
        tabs.forEach(function (o) {
          var on = o.dataset.ssb === want;
          o.classList.toggle("is-on", on);
          o.setAttribute("aria-selected", on ? "true" : "false");
        });
      }
      go("solid");

      var reduce = matchMedia("(prefers-reduced-motion:reduce)").matches;
      if (!sec || reduce) {
        /* 無釘住（或減少動態）：維持點擊切換 */
        tabs.forEach(function (t) {
          t.addEventListener("click", function () { go(t.dataset.ssb); });
        });
        return;
      }

      /* 捲動驅動：p<0.5 固態、p>=0.5 液態 */
      var ticking = false;
      function update() {
        ticking = false;
        var vh = innerHeight, r = sec.getBoundingClientRect();
        if (r.bottom < -80 || r.top > vh + 80) return;
        var h = sec.offsetHeight - vh;
        var p = (0 - r.top) / (h > 0 ? h : 1);
        if (p < 0) p = 0; else if (p > 1) p = 1;
        go(p < 0.5 ? "solid" : "liquid");
      }
      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }
      addEventListener("scroll", onScroll, { passive: true });
      addEventListener("resize", onScroll);
      update();

      /* 點分頁＝跳到那一半的捲動位置 */
      tabs.forEach(function (t) {
        t.addEventListener("click", function () {
          var top = sec.getBoundingClientRect().top + scrollY;
          var h = sec.offsetHeight - innerHeight;
          var target = top + (t.dataset.ssb === "solid" ? 0.2 : 0.75) * h;
          scrollTo({ top: target, behavior: "smooth" });
        });
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start);
    } else { start(); }
  })();
}
